import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import appReducer from "./features/app-slice";
import apiSlice from "./features/api-slice";
import adminReducer from "./features/admin-slice";
import scheduleReducer from "./features/schedule-slice";
import productReducer from "./features/product-slice";
import notificationReducer from "./features/notification-slice";
import chatReducer from "./features/chat-slice";
import ctChatReducer from "./features/ct-chat-slice";
import dashboardReducer from "./features/dashboard-slice";
import marketPlaceReducer from "./features/market-place-slice";
import formResponsesReducer from "./features/form-responses-slice";
import kanbanReducer from "./features/kanban-slice";
import kanbanApi from "./features/kanban-api";
import okrApi from "./features/okr-api";
import crmReducer from "./features/crm-slice";
import crmApi from "./features/crm-api";

export const store = configureStore({
  reducer: {
    appReducer,
    scheduleReducer: scheduleReducer,
    productReducer: productReducer,
    notificationReducer: notificationReducer,
    adminReducer,
    chatReducer: chatReducer,
    ctChatReducer: ctChatReducer,
    dashboardReducer: dashboardReducer,
    marketPlaceReducer: marketPlaceReducer,
    formResponsesReducer: formResponsesReducer,
    kanbanReducer: kanbanReducer,
    crmReducer: crmReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [kanbanApi.reducerPath]: kanbanApi.reducer,
    [okrApi.reducerPath]: okrApi.reducer,
    [crmApi.reducerPath]: crmApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware, kanbanApi.middleware, okrApi.middleware, crmApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

